import React, { useState, useRef } from "react"
import styled from 'styled-components'
import BurgerButton from './Buttons/BurgerButton'
import Menu from './Menu'
import { useOnClickOutside } from '../../hooks'

const Fixed = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  padding: 1.8rem;
  z-index: 100;
`

const BurgerMenu = ({ targets }) => {

  const [isOpen, setOpen] = useState(false)
  const node = useRef()
  useOnClickOutside(node, () => setOpen(false))

  return (
    <div ref={node}>
      <Fixed>
        <BurgerButton isOpen={isOpen} setOpen={setOpen} />
      </Fixed>
      <Menu isOpen={isOpen} setOpen={setOpen} targets={targets} />
    </div>
  )
}

export default BurgerMenu